export const USER_TYPES = {
  OPERATOR: "is_operator",
  STAFF: "is_staff",
  SUPERUSER: "is_superuser",
};
